<template >
  <div class="formways-sub-component formways-pre-loaded-files ">
    <div
      class="card fw-bg-light mb-0-5"
      v-for="file in preLoadedFiles"
      :key="file.resourceId"
    >
      <div class="card-body p-1">
        <a :href="file.url" target="__blank">{{ file.name }}</a>
        <button
          type="button"
          class="btn btn-sm fw-btn-light float-right"
          @click="deleteFile(file.resourceId)"
        >
          <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pre-loaded-files',
  props: ['files'],
  computed: {
    preLoadedFiles() {
      return this.files.filter(
        file => 'url' in file && file.isDeleted !== true
      );
    }
  },
  methods: {
    deleteFile(resourceId) {
      this.$emit('delete-file', resourceId);
    }
  }
};
</script>
